import { GLOW_TEMP_K } from "../sim/thermal";

/** Below GLOW_TEMP_K packs 0 → shader skips glow path. */
export function glowTempK(tempK: number): number {
  return tempK > GLOW_TEMP_K ? tempK : 0;
}
